import { summarizeFrameSamples } from '../../domain/perf/perfStats.js';

/**
 * perfSession — Accumulate frame samples for live / headless reports.
 */

export function createPerfSession({ now = () => Date.now() } = {}) {
  return {
    now,
    recording: false,
    frameMs: [],
    startedAt: 0,
    stopAt: 0,
    stoppedAt: 0
  };
}

export function startPerfSession(session, { seconds = 3 } = {}) {
  const t = session.now();
  session.recording = true;
  session.frameMs = [];
  session.startedAt = t;
  session.stopAt = t + Math.max(0.05, seconds) * 1000;
  session.stoppedAt = 0;
  return session;
}

export function recordFrame(session, dtSeconds) {
  if (!session.recording) return false;
  const ms = (Number(dtSeconds) || 0) * 1000;
  if (ms > 0) session.frameMs.push(ms);
  if (session.now() >= session.stopAt) {
    stopPerfSession(session);
  }
  return session.recording;
}

export function stopPerfSession(session) {
  if (!session.recording && session.stoppedAt) return session;
  session.recording = false;
  session.stoppedAt = session.now();
  return session;
}

export function buildPerfReport(session, extras = {}) {
  const end = session.stoppedAt || session.now();
  const elapsedMs = Math.max(0, end - (session.startedAt || end));
  return {
    recording: session.recording,
    elapsedMs,
    frames: summarizeFrameSamples(session.frameMs),
    ...extras
  };
}
